module.exports = __webpack_public_path__ + "static/img/role-cn.73ec28b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-3/role-cn.png
// module id = zASK
// module chunks = 1